import { RefreshCw, Wifi, WifiOff, AlertCircle } from 'lucide-react';

interface SyncIndicatorProps {
  isOnline: boolean;
  isSyncing: boolean;
  error: string | null;
  onRetry?: () => void;
}

export function SyncIndicator({ isOnline, isSyncing, error, onRetry }: SyncIndicatorProps) {
  if (isSyncing) {
    return (
      <div className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">
        <RefreshCw className="w-3.5 h-3.5 animate-spin" />
        <span>Sync</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="flex items-center gap-1.5 px-2.5 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-medium">
        <WifiOff className="w-3.5 h-3.5" />
        <span>Offline</span>
      </div>
    );
  }

  if (error) {
    return (
      <button
        onClick={onRetry}
        className="flex items-center gap-1.5 px-2.5 py-1 bg-red-50 text-red-700 rounded-full text-xs font-medium hover:bg-red-100 transition-colors"
      >
        <AlertCircle className="w-3.5 h-3.5" />
        <span>Error</span>
      </button>
    );
  }

  return (
    <div className="flex items-center gap-1.5 px-2.5 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium">
      <Wifi className="w-3.5 h-3.5" />
      <span>Online</span>
    </div>
  );
}
